import styled from 'styled-components';

export const Label = styled.label`
  font-size: ${props => props.theme.fontSizeSmall};
  line-height: 1;
  color: ${props => props.theme.smallFontColor};
  padding-top: 0;
  padding-bottom: 3px;
`;

export const HelpLabel = styled.label`
  color: ${props => props.theme.fontColorPrimary};
  font-size: ${props => props.theme.helpLabelFontSize};
  font-family: ${props => props.theme.fontFamilyLight};
  padding-bottom: 10px;
`;
